import { colors } from "../../data/colors";
import { stdObject } from "../../data/types/stdObject";
import BasicButton from "../BasicButton";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PendingIcon from "@mui/icons-material/Pending";
import SearchIcon from "@mui/icons-material/Search";
import convertDate from "../../utils/convertDate";
import { useTranslation } from "react-i18next";
import BasicInput from "../BasicInput";
import IssuesTypeInput from "./IssuesTypeInput";
import { SetStateAction, useRef, useState } from "react";
import { useDocContext, useMainContext } from "../../context/MainContext";
import { salesCodes } from "../../data/main";
import QuickSearchComp from "../QuickSearchComp";
import {
  cleanDocPerson,
  openCasualPerson,
} from "../../screens/MainFrame/functions/document/openCasualPerson";
import { insertNewPerson } from "../../screens/MainFrame/functions/insertNewPerson";
import { RootState } from "../../store/store";
import { useSelector } from "react-redux";
import CommissionBar from "../DocumentModal/components/CommissionBar";

export default function DocSection({
  title,
  type = "",
  mainWidth = false,
  mainColor = colors.blue,
  data = [],
  issues = false,
  tax = false,
  onChange,
  openRecords = () => {},
  initOwner = "",
  personCode = "",
  globalActive,
  minSizeDoc,
}: {
  title?: string;
  type?: string;
  mainWidth: boolean;
  mainColor?: string;
  issues?: boolean;
  data?: Array<any>;
  tax?: stdObject | boolean;
  onChange?: any;
  openRecords?: any;
  initOwner?: string;
  personCode?: string;
  globalActive?: boolean;
  minSizeDoc?: boolean;
}) {
  const { t } = useTranslation();
  const user: any = useSelector((state: RootState) => state.data.user);
  const userAccess: stdObject = useSelector(
    (state: RootState) => state.data.userAccess,
  );
  const refQuickPerson = useRef<HTMLInputElement>(null);
  const [quickPerson, setQuickPerson] = useState({
    code: "",
    open: false,
    search: "",
  });
  const { docActive } = useDocContext();
  const {
    setMsg,
    setWindowValues,
    docValues,
    setDocValues,
    updateDocData,
    openItemOptions,
    openWindow,
  } = useMainContext();
  const docValueToMask = (
    key: string,
    value: string | number | null | undefined,
  ) => {
    switch (key) {
      case "FEC":
      case "FEC2":
        return typeof value === "string" && value !== ""
          ? convertDate({ info: value.toString(), t })
          : value;
      case "EST3":
        return [t("p.active"), t("p.opened"), t("p.canceled")][Number(value)];
      default:
        return value;
    }
  };

  return (
    <div
      className="docSection noSelect"
      style={{
        marginTop: title ? 15 : 0,
      }}
    >
      {title && <div className="titleDocSection">{title}</div>}
      <div className="wrapBox" style={{ padding: 0, gap: 5 }}>
        {data.map((e, index) =>
          e && issues ? (
            <IssuesTypeInput
              key={index}
              data={e}
              mainWidth={mainWidth}
              initOwner={initOwner}
              minSizeDoc={minSizeDoc}
            />
          ) : (
            e && (
              <div
                key={index}
                style={{
                  position: "relative",
                  padding: 3,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                {e.type === "button" && globalActive ? (
                  <BasicButton
                    key={index}
                    title={e.label}
                    color={mainColor}
                    onClick={() => {
                      ["CLI", "RES"].includes(e.key)
                        ? setQuickPerson({
                            ...quickPerson,
                            open: true,
                            code: e.key,
                          })
                        : e.onClick({
                            key: e.key,
                            field: e.field,
                            value: e.value,
                          });
                    }}
                  />
                ) : (
                  <BasicButton
                    key={index}
                    title={e.label}
                    color={colors.darkGrey}
                    onClick={() => {}}
                  />
                )}
                {["select"].includes(e.type) ? (
                  <>
                    <BasicInput
                      key={index}
                      value={e.value}
                      active={
                        (e.key === "PAG" &&
                          [3, 5].includes(user.TEC) &&
                          docActive.status < 2) ||
                        (globalActive && e.active)
                      }
                      type={e.type}
                      options={e.options}
                      onChange={(v: {
                        target: { value: SetStateAction<string> };
                      }) => onChange(e.key, v.target.value)}
                      style={{ marginBottom: 0, marginLeft: 5 }}
                    />
                    {e.key === "PRE" && typeof tax === "object" && (
                      <>
                        <BasicInput
                          value={tax.value}
                          active={globalActive && tax.active}
                          type={tax.type}
                          options={tax.options}
                          onChange={(v: {
                            target: { value: SetStateAction<string> };
                          }) =>
                            globalActive ? onChange("PIM", v.target.value) : {}
                          }
                          style={{ marginBottom: 0, marginLeft: 5 }}
                        />
                        {globalActive && docActive.items && (
                          <div style={{ position: "relative", marginLeft: 5 }}>
                            <CommissionBar
                              comm={docValues.commissions}
                              line={0}
                              style={{ top: -5, right: 0 }}
                            />
                            <PendingIcon
                              onClick={() => {
                                openItemOptions(-1, e);
                              }}
                              style={{
                                color: colors.darkGrey,
                                cursor: "pointer",
                                marginLeft: 3,
                              }}
                            />
                          </div>
                        )}
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {globalActive &&
                      ["CLI"].includes(e.key) &&
                      salesCodes.includes(type) && (
                        <SearchIcon
                          onClick={() => {
                            e.onClick({
                              key: e.key,
                              field: e.field,
                              value: e.value,
                            });
                          }}
                          style={{ color: colors.darkGrey, cursor: "pointer" }}
                        />
                      )}
                    <div style={{ marginLeft: 5 }}>
                      {!e.hideCode && (
                        <span>{docValueToMask(e.key, e.value)}</span>
                      )}
                      {e.value !== "" && <div>{e.name}</div>}
                    </div>
                    {type === "SEV" &&
                      e.key === "CLI" &&
                      e.value !== "" &&
                      !!userAccess.C.C1R && (
                        <CalendarMonthIcon
                          onClick={openRecords}
                          style={{ color: colors.darkGrey, cursor: "pointer" }}
                        />
                      )}
                  </>
                )}
                {quickPerson.code === e.key && quickPerson.open && (
                  <QuickSearchComp
                    type={personCode}
                    searchType={personCode}
                    refInput={refQuickPerson}
                    inputData={quickPerson}
                    setInputData={setQuickPerson}
                    updateFunction={updateDocData}
                    newFunction={() =>
                      insertNewPerson(quickPerson.code, {
                        t,
                        mainColor: docValues.typeText,
                        openWindow,
                      })
                    }
                    casualFunction={() => {
                      openCasualPerson({
                        t,
                        type: quickPerson.code,
                        docData: docValues,
                        isDoc: true,
                        setMsg,
                        setWindowValues,
                      });
                    }}
                    cleanFunction={() => {
                      cleanDocPerson({
                        code: quickPerson.code,
                        docValues,
                        setDocValues,
                      });
                    }}
                  />
                )}
              </div>
            )
          ),
        )}
      </div>
    </div>
  );
}
